export enum RewriteError {
  // Can be populated only on Extension side
  PROSPECT_LINKEDIN_URL_MISSING = 'ProspectLinkedinUrlMissing',
  COMPANY_LINKEDIN_URL_MISSING = 'CompanyLinkedinUrlMissing',
  UNHANDLED_ERROR_ON_EXTENSION = 'UnhandledErrorOnExtension',

  // Can be populated only on BE side
  UNHANDLED_ERROR = 'UnhandledError',
  ERROR_RELATED_TO_AI_MODEL = 'ErrorRelatedToAiModel',
  EXTENSION_NOT_AVAILABLE_DURING_INSERT = 'ExtensionNotAvailableDuringInsert',
  REPLACE_TEMPLATE_VARIABLES_ERROR = 'ReplaceTemplateVariablesError',
  CREDITS_RELATED_ERROR = 'CreditsRelatedError',
  PERSONALIZED_TEMPLATE_RELATED_ERROR = 'PersonalizedTemplateRelatedError',
  FAILED_TO_PUBLISH_MESSAGE_TO_QUEUE_ERROR = 'FailedToPublishMessageToQueueError',
  FAILED_TO_RETRIEVE_USER_ERROR = 'FailedToRetrieveUserError',
  RETRIEVE_SEQUENCE_PROSPECT_ERROR = 'RetrieveSequenceProspectError',
}
